import React, { createContext, useState, useCallback, useEffect } from "react";

const API_URL = process.env.REACT_APP_API_URL || 'https://pyate-backend-production-f7ce.up.railway.app';

const CartContext = createContext({
  cartCount: 0,
  setCartCount: () => {},
  fetchCartCount: () => {},
  cartItems: [],
  setCartItems: () => {},
});

export const CartProvider = ({ children }) => {
  const [cartCount, setCartCount] = useState(0);
  const [cartItems, setCartItems] = useState([]);
  const [currentUserId, setCurrentUserId] = useState(null);
  const API_URL = process.env.REACT_APP_API_URL || 'https://pyate-backend-production-9749.up.railway.app';

  // Read user_id from localStorage — saved at login time.
  // No API call needed. Was previously calling /api/get-user-id
  // on every render which caused 15+ duplicate requests.
  const getUserId = () => localStorage.getItem('user_id');

  const fetchCartCount = useCallback(async (signal) => {
    const token = localStorage.getItem('token');
    const userId = getUserId();

    if (!token || !userId) {
      setCartCount(0);
      setCartItems([]);
      return;
    }

    try {
      const res = await fetch(`${API_URL}/api/get_cart_items?user_id=${userId}`, {
        signal,
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (res.ok) {
        const data = await res.json();
        setCartItems(data);
        setCartCount(data.length);
      } else {
        setCartCount(0);
        setCartItems([]);
      }
    } catch (error) {
      if (error.name === 'AbortError') return;
      console.error('Error fetching cart items:', error);
      setCartCount(0);
      setCartItems([]);
    }
  }, []);

  // Initial fetch + polling every 30s
  useEffect(() => {
    const controller = new AbortController();
    fetchCartCount(controller.signal);
    const intervalId = setInterval(() => fetchCartCount(), 30000);

    // Re-fetch when token changes (login/logout)
    const handleStorageChange = (event) => {
      if (event.key === 'token' || event.key === 'user_id') {
        fetchCartCount();
      }
    };
    window.addEventListener('storage', handleStorageChange);

    return () => {
      controller.abort();
      clearInterval(intervalId);
      window.removeEventListener('storage', handleStorageChange);
    };
  }, [fetchCartCount]);

  return (
    <CartContext.Provider value={{
      cartCount,
      setCartCount,
      fetchCartCount,
      cartItems,
      setCartItems
    }}>
      {children}
    </CartContext.Provider>
  );
};

export default CartContext;